import Buy from "../components/Buy";
import Contact from "../components/Contact";
import Introduction from "../components/Introduction";
import Navbar from "../components/Navbar";
import Tokenomics from "../components/Tokenomics";
import { motion } from "framer-motion"



export default function Home() {
      
    return (
        <div className="md:px-14 py-6 bg-blue-400 background min-h-screen flex flex-col">
            <motion.div  initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ duration: 1.5 }}>
                <Navbar />
                <Introduction />
                <Buy />
                <Tokenomics />
                <Contact />
            </motion.div>
        </div>
    )
}
